module.exports = __webpack_public_path__ + "img/canbadge_daishi_50_60mm_line.5b98cb92.png";